<template>
  <div class="noticeComponent">
    <div class="noticeMenu" @click="showNotice">
      <span class="hasNewNotice" v-if="hasNewNotice"></span>
      <span>通知中心</span>
    </div>
    <Modal v-model="noticeOpen" v-if="noticeOpen" title="通知中心" width="800px">
      <Spin :spinning="loadding">
        <Tabs @change.self="switchNoticeCate" v-model="tabKey">
          <TabPane tab="未读" key="0">
            <List itemLayout="horizontal" :dataSource="noticeList" :pagination="pagination">
              <ListItem slot="renderItem" slot-scope="item" @click="updateNotice(item)">
                <ListItemMeta>
                  <div slot="title">
                    <div class="noticeTime">{{item.send_time}}</div>
                    <div class="noticeContent">{{item.content}}</div>
                  </div>
                  <div slot="avatar" class="unreadDot"></div>
                </ListItemMeta>
              </ListItem>
            </List>
          </TabPane>
          <TabPane tab="已读" key="1">
            <List itemLayout="horizontal" :dataSource="noticeList" :pagination="pagination">
              <ListItem slot="renderItem" slot-scope="item">
                <ListItemMeta>
                  <div slot="title">
                    <div class="noticeTime">{{item.send_time}}</div>
                    <div class="noticeContent">{{item.content}}</div>
                  </div>
                </ListItemMeta>
              </ListItem>
            </List>
          </TabPane>
          <Button slot="tabBarExtraContent" type="link" @click="readAll">全部标为已读</Button>
        </Tabs>
      </Spin>
      <div slot="footer">
        <Button type="primary" size="large" @click="closeNotice">返回</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getNoticeList, updateAllNoticeReaded, updateSingleNoticeReaded } from '../../api/user'
import { Modal, Button, Spin, Tabs, List } from 'ant-design-vue'
import { toast } from '../../libs/utils'
import { mapState, mapActions } from 'vuex'
import { isJSONStr } from '../../libs/tool'
export default {
  components: {
    Modal,
    Button,
    Spin,
    Tabs,
    TabPane: Tabs.TabPane,
    List,
    ListItem: List.Item,
    ListItemMeta: List.Item.Meta
  },
  data () {
    return {
      noticeOpen: false,
      loadding: false,
      noticeList: [],
      tabKey: '0',
      pagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        onChange: pageNo => this.changePageNo(pageNo)
      }
    }
  },
  watch: {
    noticeOpen (newVal) {
      if (!newVal) this.pagination.current = 1
    }
  },
  methods: {
    ...mapActions([
      'setHasNewNotice'
    ]),
    async showNotice () {
      this.noticeOpen = !this.noticeOpen
      if (this.noticeOpen) {
        await this.switchNoticeCate(0)
      }
    },
    closeNotice () {
      this.noticeOpen = false
    },
    async readAll () {
      let data = await updateAllNoticeReaded({allReadFlag: true})
      if (data) {
        toast({msg: '消息已经全部标记为已读', title: '提示', type: 'success'})
        if (this.tabKey === '0') await this.switchNoticeCate(0)
        this.setHasNewNotice(false)
      }
    },
    async getNotices () {
      let params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        readFlag: this.tabKey
      }
      this.noticeList = []
      let list = await getNoticeList(params)
      if (list && list.totalCount) {
        this.noticeList = this.dealListContent(list.results)
        this.pagination.total = list.totalCount
      } else {
        this.setHasNewNotice(false)
      }
    },
    async switchNoticeCate (key) {
      this.tabKey = key.toString()
      this.pagination.total = 0
      this.noticeList = []
      await this.getNotices()
    },
    async updateNotice (item) {
      let data = await updateSingleNoticeReaded({uuid: item.content_title})
      if (data) {
        this.pagination.current = 1
        await this.getNotices()
      }
    },
    async changePageNo (pageNo) {
      this.pagination.current = pageNo
      await this.getNotices()
    },
    dealListContent (arr = []) {
      for(let i = 0; i < arr.length; i++) {
        let item = arr[i]
        let jsonObj = isJSONStr(item.content)
        if (jsonObj) {
          if (jsonObj.type === 'pay') {
            item.content = `${jsonObj.title}:${jsonObj.name}-${jsonObj.payType || ''}-${jsonObj.totalAmount || 0}元`
          } else if (jsonObj.type === 'reception') {
            item.content = `扫码报到:${jsonObj.name || ''}-${jsonObj.gender || ''}-${jsonObj.birthDate || 0}`
          }
        }
        continue
      }
      return arr
    }
  },
  computed: {
    ...mapState({
      hasNewNotice: state => state.app.hasNewNotice
    })
  }
}
</script>
<style lang="less">
.noticeComponent{
  margin-right: 20px;
  cursor: pointer;
  .noticeMenu{
    display: flex;
    align-items: center;
    color:#fff;
    .hasNewNotice{
      width: 10px;
      height: 10px;
      background-color: #1890ff;
      border-radius: 50%;
    }
  }
  @media screen and (max-width: 576px) {
    .noticeMenu{
      position: relative;
      .hasNewNotice{
        position: absolute;
        left: -27%;;
        top: 21%;
      }
    }
  }
}
.ant-list-item-meta{
  align-items: center;
  .unreadDot{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #1890ff;
  }
}

</style>